/**
 * filter for checking exclusive extras,
 * if an extra category is exclusive and an extra is taken already from that category then no other extras should be
 * allowed to be chosen from the category
 */
bookingApp.filter('extraCategoryExclusive',['$filter', function(){
    var extrasCategoryFilter = function(input, cart){
        var out = [];
        angular.forEach(input, function(extra){
            if(extra.category.isExclusive){
                var categoryFoundInCart = false;
                // check if cart already has an extra from this category
                angular.forEach(cart.rooms, function(room){
                    angular.forEach(room.selectedExtras, function(roomExtra){
                        if(extra.category.id === roomExtra.extra.category.id){
                            categoryFoundInCart = true;
                        }
                    });
                });
                angular.forEach(cart.bookingExtras.selected, function(bookingExtra){
                    if(extra.category.id === bookingExtra.extra.category.id){
                        categoryFoundInCart = true;
                    }
                });
                if(!categoryFoundInCart){
                    out.push(extra);
                }
            }else{
                out.push(extra);
            }
        });
        return out;
    };
    return extrasCategoryFilter;
}]);
